import React, {useEffect} from 'react';
import {Button, Form, Grid, Popup} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import {Actions} from '../../../../common/actions';
import {downloadFile} from '../../../../common/util/file';
import {connect, useSelector, useDispatch} from 'react-redux';
import moment from 'moment';
import {noTimeZoneFullISODate} from '../../../../common/constants/datesFormat';
import {mapListToDropdownList} from '../../../utils/commonUtils';
import {debounce} from 'lodash';

const initialData = {
  'order': '',
  'line': '',
  'chassis': '',
  'dealer': '',
  'dateFrom': null,
  'dateTo': null,
};

const SearchFloatingInventory = ({
  cleanFloatingAuditScreen,
  fetchAuditFloatingInventory,
  fetchFloatingInventoryAuditOrder,
  fetchFloatingInventoryAuditChassis,
  floatingInventoryList,
  listDealers,
  setResetAllFilters,
  setShowFilters,
  showFilters,
  fetchAuditFloatingInventoryExcel,
  clearFloatInventoryAudit,
}) => {
  const [data, setData] = React.useState(initialData);
  const dispatch = useDispatch();
  const dowloadAuditFloatingReportWait = useSelector((state) => state.dowloadAuditFloatingReportWait);
  const {url} = dowloadAuditFloatingReportWait;

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchAuditFloatingInventory(data);
  };
  
  const handleSubmitExcel = (e) => {
    e.preventDefault();
    fetchAuditFloatingInventoryExcel(data);
  };
  const handleChange = (e, {name, value}) => {
    setData({...data, [name]: value});
  };

  const handleSelectorChange = (name, value) => {
    setData({...data, [name]: value});
    if (value.length > 2) {
      if (name === 'order') {
        fetchFloatingInventoryAuditOrder(name, value);
      } else if (name === 'chassis') {
        fetchFloatingInventoryAuditChassis(name, value);
      }
    }
  };

  const debouncedHandleSelectorChange = debounce(handleSelectorChange, 600);

  useEffect(() => {
    if (url) {
      downloadFile(url);
      dispatch(clearFloatInventoryAudit());
    }
  }, [url, dispatch, clearFloatInventoryAudit]);

  const handleCleanFilters = () => {
    setData(initialData);
    setResetAllFilters(true);
    cleanFloatingAuditScreen();
  };

  const handleShowFilters = () => {
    setShowFilters(!showFilters);
  };
  return (
    <>
      <Grid
        stackable
        fluid
        className='no-space w-100'
        textAlign='left'
        columns={1}>
        <Grid.Row width={16} columns={6} className='no-space'>
          <Grid.Column width={3}>
            <Form.Select
              label='PEDIDO:'
              className='selector-tiny-size small-label-custom floating-inventory-full-width'
              placeholder='SELECCIONAR...'
              name='order'
              size='mini'
              search
              value={data.order}
              onChange={handleChange}
              onKeyUp={(e) => debouncedHandleSelectorChange('order', e.target.value)}
              options={floatingInventoryList?.order?.data}
              loading={floatingInventoryList?.order?.loading}
              noResultsMessage='No se encontraron resultados...'
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <Form.Input
              label='LÍNEA:'
              className='small-label-custom floating-inventory-full-width'
              size='mini'
              name='line'
              value={data.line}
              onChange={handleChange}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <Form.Select
              label='CHASIS:'
              className='selector-tiny-size small-label-custom floating-inventory-full-width'
              placeholder='SELECCIONAR...'
              name='chassis'
              size='mini'
              search
              value={data.chassis}
              onChange={handleChange}
              onKeyUp={(e) => debouncedHandleSelectorChange('chassis', e.target.value)}
              options={floatingInventoryList?.chassis?.data}
              loading={floatingInventoryList?.chassis?.loading}
              noResultsMessage='No se encontraron resultados...'
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <Form.Select
              label='DEALER'
              className='selector-tiny-size small-label-custom floating-inventory-full-width'
              placeholder='SELECCIONAR...'
              name='dealer'
              size='mini'
              search
              value={data.dealer}
              onChange={handleChange}
              noResultsMessage='No se encontraron resultados...'
              options={mapListToDropdownList(
                listDealers,
                {
                  'keys': ['identification'],
                  'values': ['identification'],
                  'texts': ['name'],
                }, true)}
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <DatePicker
              name='dateFrom'
              placeholderText='SELECCIONAR...'
              showYearDropdown
              selected={data.dateFrom ? moment(data.dateFrom, noTimeZoneFullISODate).toDate() : null}
              onChange={(value) => handleChange(
                null,
                {
                  'name': 'dateFrom',
                  'value': moment(value).format(noTimeZoneFullISODate),
                }
              )}
              customInput={
                <Form.Input
                  icon='calendar'
                  className='small-label-custom calendar-input-floating floating-inventory-full-width'
                  size='mini'
                  label='DESDE:'
                />
              }
              locale='es'
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <DatePicker
              name='dateTo'
              placeholderText='SELECCIONAR...'
              showYearDropdown
              selected={data.dateTo ? moment(data.dateTo, noTimeZoneFullISODate).toDate() : null}
              onChange={(value) => handleChange(
                null,
                {
                  'name': 'dateTo',
                  'value': moment(value).format(noTimeZoneFullISODate),
                }
              )}
              customInput={
                <Form.Input
                  icon='calendar'
                  className='small-label-custom calendar-input-floating floating-inventory-full-width'
                  size='mini'
                  label='HASTA:'
                  placeholder=' - '
                />
              }
              locale='es'
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <div className='button-section-float-search-card'>
        <Button
          type='button'
          size='mini'
          basic
          compact
          color='grey'
          onClick={handleShowFilters}
        >
          {showFilters ? 'OCULTAR FILTROS DE TABLA' : 'MOSTRAR FILTROS DE TABLA'}
        </Button>
        <Button
          type='button'
          size='mini'
          basic
          compact
          color='grey'
          onClick={handleCleanFilters}
        >
            LIMPIAR FILTROS
        </Button>
        <Popup
          trigger={
            <span>
              <Button
                type='button'
                size='mini'
                compact
                color='grey'
                onClick={handleSubmit}
                primary
                disabled={!((data.order && data.line) || data.chassis)}
              >
                BUSCAR
              </Button>
            </span>
          }
          content={'La búsqueda se debe realizar por Pedido-Línea o por Chasis.'}
          position='top center'
          size='small'
          style={{'maxWidth': '150px'}}
          inverted
          disabled={(data.order && data.line) || data.chassis}
        />
        <Popup
          trigger={
            <span>
              <Button
                type='button'
                size='mini'
                compact
                color='grey'
                onClick={handleSubmitExcel}
                primary
                disabled={!((data.order && data.line) || data.chassis)}
              >
                EXPORTAR
              </Button>
            </span>
          }
          content={'La búsqueda se debe realizar por Pedido-Línea o por Chasis.'}
          position='top center'
          size='small'
          style={{'maxWidth': '150px'}}
          inverted
          disabled={(data.order && data.line) || data.chassis}
        />
      </div>
    </>
  );
};


const mapStateToProps = (state) => {
  return {
    'listDealers': state.dealer.list,
  };
};

const {
  cleanFloatingAuditScreen,
  fetchAuditFloatingInventory,
  fetchFloatingInventoryAuditOrder,
  fetchFloatingInventoryAuditChassis,
  fetchAuditFloatingInventoryExcel,
  clearFloatInventoryAudit,
} = Actions;

export default connect(mapStateToProps, {
  cleanFloatingAuditScreen,
  fetchAuditFloatingInventory,
  fetchFloatingInventoryAuditOrder,
  fetchFloatingInventoryAuditChassis,
  fetchAuditFloatingInventoryExcel,
  clearFloatInventoryAudit,
})(SearchFloatingInventory);
